// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.15.3
//   protoc               v7.36.2
// source: proto/variable_schema.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { EnumSchema, VariableDesc, VariableSource, variableSourceFromJSON, variableSourceToJSON } from "./common";

export const protobufPackage = "protobuf.variables";

/** Which descendants can see a variable a node publishes. */
export enum NodeVariableScope {
  /** GLOBAL - Visible to all descendants. */
  GLOBAL = 0,
  /** SUBGRAPH - Visible only inside this node's subgraph. Only a node that owns a subgraph may declare it. */
  SUBGRAPH = 1,
  UNRECOGNIZED = -1,
}

export function nodeVariableScopeFromJSON(object: any): NodeVariableScope {
  switch (object) {
    case 0:
    case "GLOBAL":
      return NodeVariableScope.GLOBAL;
    case 1:
    case "SUBGRAPH":
      return NodeVariableScope.SUBGRAPH;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NodeVariableScope.UNRECOGNIZED;
  }
}

export function nodeVariableScopeToJSON(object: NodeVariableScope): string {
  switch (object) {
    case NodeVariableScope.GLOBAL:
      return "GLOBAL";
    case NodeVariableScope.SUBGRAPH:
      return "SUBGRAPH";
    case NodeVariableScope.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** A test against one field of a Logiblocks node's configuration. */
export interface NodeDataMatch {
  /** Name of the node setting to test, e.g. "wait_for_response". */
  field: string;
  /**
   * Values that satisfy the test.
   * A setting holding a list matches when it contains one of these. Bools use "true" and "false".
   * A setting that is a nested message holds the one value "set" when it is present and no value
   * when it is not, which is how a one-of option is tested.
   */
  equals: string[];
}

/** One variable a Logiblocks node type publishes. */
export interface NodeOutput {
  variable: VariableDesc | undefined;
  scope: NodeVariableScope;
  /** Tests that all have to hold for the variable to be published. Empty means always published. */
  published_when: NodeDataMatch[];
  /**
   * Who declared the variable. The definitions file declares node-type outputs
   * only, so the loader sets this rather than reading it; code that publishes
   * an author's variable sets SOURCE_USER.
   */
  source: VariableSource;
}

/** What one Logiblocks node type publishes, and whether test runs support it. */
export interface NodeTypeSchema {
  /** Key of this node type's variant in the LBNodeData oneof, e.g. "sms_action". */
  proto_oneof_key: string;
  outputs: NodeOutput[];
  /**
   * True when a test run accepts a workflow containing this node type. The node type's backend
   * class then overrides `execute_test_run`.
   */
  supports_test_runs: boolean;
}

/** Everything the variable definitions file declares. */
export interface VariableDefinitions {
  node_types: NodeTypeSchema[];
  enums: EnumSchema[];
  /**
   * Fields an AI agent can be asked to find out during a call. An author picks from these when
   * setting up an AI call node, and the picked entry is copied onto the node as a declaration.
   * Names are keys here, because an agent and a success criteria both refer to an entry by name.
   */
  agent_pca_collect_catalog: VariableDesc[];
}

function createBaseNodeDataMatch(): NodeDataMatch {
  return { field: "", equals: [] };
}

export const NodeDataMatch: MessageFns<NodeDataMatch> = {
  encode(message: NodeDataMatch, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.field !== "") {
      writer.uint32(10).string(message.field);
    }
    for (const v of message.equals) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodeDataMatch {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseNodeDataMatch();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.field = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.equals.push(reader.string());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): NodeDataMatch {
    return {
      field: isSet(object.field) ? globalThis.String(object.field) : "",
      equals: globalThis.Array.isArray(object?.equals) ? object.equals.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: NodeDataMatch): unknown {
    const obj: any = {};
    if (message.field !== "") {
      obj.field = message.field;
    }
    if (message.equals?.length) {
      obj.equals = message.equals;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NodeDataMatch>, I>>(base?: I): NodeDataMatch {
    return NodeDataMatch.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodeDataMatch>, I>>(object: I): NodeDataMatch {
    const message = createBaseNodeDataMatch();
    message.field = object.field ?? "";
    message.equals = object.equals?.map((e) => e) || [];
    return message;
  },
};

function createBaseNodeOutput(): NodeOutput {
  return { variable: undefined, scope: 0, published_when: [], source: 0 };
}

export const NodeOutput: MessageFns<NodeOutput> = {
  encode(message: NodeOutput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.variable !== undefined) {
      VariableDesc.encode(message.variable, writer.uint32(10).fork()).join();
    }
    if (message.scope !== 0) {
      writer.uint32(16).int32(message.scope);
    }
    for (const v of message.published_when) {
      NodeDataMatch.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.source !== 0) {
      writer.uint32(32).int32(message.source);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodeOutput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseNodeOutput();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.variable = VariableDesc.decode(reader, reader.uint32());
            continue;
          }
          case 2: {
            if (tag !== 16) {
              break;
            }

            message.scope = reader.int32() as any;
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.published_when.push(NodeDataMatch.decode(reader, reader.uint32()));
            continue;
          }
          case 4: {
            if (tag !== 32) {
              break;
            }

            message.source = reader.int32() as any;
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): NodeOutput {
    return {
      variable: isSet(object.variable) ? VariableDesc.fromJSON(object.variable) : undefined,
      scope: isSet(object.scope) ? nodeVariableScopeFromJSON(object.scope) : 0,
      published_when: globalThis.Array.isArray(object?.publishedWhen)
        ? object.publishedWhen.map((e: any) => NodeDataMatch.fromJSON(e))
        : globalThis.Array.isArray(object?.published_when)
        ? object.published_when.map((e: any) => NodeDataMatch.fromJSON(e))
        : [],
      source: isSet(object.source) ? variableSourceFromJSON(object.source) : 0,
    };
  },

  toJSON(message: NodeOutput): unknown {
    const obj: any = {};
    if (message.variable !== undefined) {
      obj.variable = VariableDesc.toJSON(message.variable);
    }
    if (message.scope !== 0) {
      obj.scope = nodeVariableScopeToJSON(message.scope);
    }
    if (message.published_when?.length) {
      obj.publishedWhen = message.published_when.map((e) => NodeDataMatch.toJSON(e));
    }
    if (message.source !== 0) {
      obj.source = variableSourceToJSON(message.source);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NodeOutput>, I>>(base?: I): NodeOutput {
    return NodeOutput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodeOutput>, I>>(object: I): NodeOutput {
    const message = createBaseNodeOutput();
    message.variable = (object.variable !== undefined && object.variable !== null)
      ? VariableDesc.fromPartial(object.variable)
      : undefined;
    message.scope = object.scope ?? 0;
    message.published_when = object.published_when?.map((e) => NodeDataMatch.fromPartial(e)) || [];
    message.source = object.source ?? 0;
    return message;
  },
};

function createBaseNodeTypeSchema(): NodeTypeSchema {
  return { proto_oneof_key: "", outputs: [], supports_test_runs: false };
}

export const NodeTypeSchema: MessageFns<NodeTypeSchema> = {
  encode(message: NodeTypeSchema, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.proto_oneof_key !== "") {
      writer.uint32(10).string(message.proto_oneof_key);
    }
    for (const v of message.outputs) {
      NodeOutput.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.supports_test_runs !== false) {
      writer.uint32(24).bool(message.supports_test_runs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NodeTypeSchema {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseNodeTypeSchema();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.proto_oneof_key = reader.string();
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.outputs.push(NodeOutput.decode(reader, reader.uint32()));
            continue;
          }
          case 3: {
            if (tag !== 24) {
              break;
            }

            message.supports_test_runs = reader.bool();
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): NodeTypeSchema {
    return {
      proto_oneof_key: isSet(object.protoOneofKey)
        ? globalThis.String(object.protoOneofKey)
        : isSet(object.proto_oneof_key)
        ? globalThis.String(object.proto_oneof_key)
        : "",
      outputs: globalThis.Array.isArray(object?.outputs) ? object.outputs.map((e: any) => NodeOutput.fromJSON(e)) : [],
      supports_test_runs: isSet(object.supportsTestRuns)
        ? globalThis.Boolean(object.supportsTestRuns)
        : isSet(object.supports_test_runs)
        ? globalThis.Boolean(object.supports_test_runs)
        : false,
    };
  },

  toJSON(message: NodeTypeSchema): unknown {
    const obj: any = {};
    if (message.proto_oneof_key !== "") {
      obj.protoOneofKey = message.proto_oneof_key;
    }
    if (message.outputs?.length) {
      obj.outputs = message.outputs.map((e) => NodeOutput.toJSON(e));
    }
    if (message.supports_test_runs !== false) {
      obj.supportsTestRuns = message.supports_test_runs;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NodeTypeSchema>, I>>(base?: I): NodeTypeSchema {
    return NodeTypeSchema.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NodeTypeSchema>, I>>(object: I): NodeTypeSchema {
    const message = createBaseNodeTypeSchema();
    message.proto_oneof_key = object.proto_oneof_key ?? "";
    message.outputs = object.outputs?.map((e) => NodeOutput.fromPartial(e)) || [];
    message.supports_test_runs = object.supports_test_runs ?? false;
    return message;
  },
};

function createBaseVariableDefinitions(): VariableDefinitions {
  return { node_types: [], enums: [], agent_pca_collect_catalog: [] };
}

export const VariableDefinitions: MessageFns<VariableDefinitions> = {
  encode(message: VariableDefinitions, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.node_types) {
      NodeTypeSchema.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.enums) {
      EnumSchema.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.agent_pca_collect_catalog) {
      VariableDesc.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): VariableDefinitions {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const previousRecursionDepth = (reader as any).__tsProtoDecodeDepth ?? 0;
    if (previousRecursionDepth >= 100) {
      throw new globalThis.Error("protobuf decode recursion limit exceeded");
    }
    (reader as any).__tsProtoDecodeDepth = previousRecursionDepth + 1;
    try {
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseVariableDefinitions();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 10) {
              break;
            }

            message.node_types.push(NodeTypeSchema.decode(reader, reader.uint32()));
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.enums.push(EnumSchema.decode(reader, reader.uint32()));
            continue;
          }
          case 3: {
            if (tag !== 26) {
              break;
            }

            message.agent_pca_collect_catalog.push(VariableDesc.decode(reader, reader.uint32()));
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    } finally {
      (reader as any).__tsProtoDecodeDepth = previousRecursionDepth;
    }
  },

  fromJSON(object: any): VariableDefinitions {
    return {
      node_types: globalThis.Array.isArray(object?.nodeTypes)
        ? object.nodeTypes.map((e: any) => NodeTypeSchema.fromJSON(e))
        : globalThis.Array.isArray(object?.node_types)
        ? object.node_types.map((e: any) => NodeTypeSchema.fromJSON(e))
        : [],
      enums: globalThis.Array.isArray(object?.enums) ? object.enums.map((e: any) => EnumSchema.fromJSON(e)) : [],
      agent_pca_collect_catalog: globalThis.Array.isArray(object?.agentPcaCollectCatalog)
        ? object.agentPcaCollectCatalog.map((e: any) => VariableDesc.fromJSON(e))
        : globalThis.Array.isArray(object?.agent_pca_collect_catalog)
        ? object.agent_pca_collect_catalog.map((e: any) => VariableDesc.fromJSON(e))
        : [],
    };
  },

  toJSON(message: VariableDefinitions): unknown {
    const obj: any = {};
    if (message.node_types?.length) {
      obj.nodeTypes = message.node_types.map((e) => NodeTypeSchema.toJSON(e));
    }
    if (message.enums?.length) {
      obj.enums = message.enums.map((e) => EnumSchema.toJSON(e));
    }
    if (message.agent_pca_collect_catalog?.length) {
      obj.agentPcaCollectCatalog = message.agent_pca_collect_catalog.map((e) => VariableDesc.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<VariableDefinitions>, I>>(base?: I): VariableDefinitions {
    return VariableDefinitions.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VariableDefinitions>, I>>(object: I): VariableDefinitions {
    const message = createBaseVariableDefinitions();
    message.node_types = object.node_types?.map((e) => NodeTypeSchema.fromPartial(e)) || [];
    message.enums = object.enums?.map((e) => EnumSchema.fromPartial(e)) || [];
    message.agent_pca_collect_catalog = object.agent_pca_collect_catalog?.map((e) => VariableDesc.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
